// Auto-split from i18n.js — language: tr
export default {
    translation: {
        // routes & menus
        Dashboard: 'Tablo',
        'Space Data': 'Uzay',
        'Equipment Data': 'Ekipman',
        'Meter Data': 'Metre',
        'Tenant Data': 'Kiracı',
        'Store Data': 'Mağaza',
        'Shopfloor Data': 'Üretim bölümü',
        'Combined Equipment Data': 'Kombine Ekipmanlar',
        'Auxiliary System': 'Yardımcı Sistem',
        Microgrid: 'Mikro şebeke',
        'Energy Storage Power Station': 'Güç İstasyonu',
        'Photovoltaic Power Station': 'Güç İstasyonu',
        'Fault Alarm': 'Arıza Alarmı',
        Monitoring: 'Izleme',
        'Advanced Reporting': 'Gelişmiş Raporlama',
        'Knowledge Base': 'Bilgi bankası',
        'Energy Category Data': 'Enerji Kategorisi',
        'Energy Item Data': 'Enerji Öğesi',
        Carbon: 'CO2 Emisyonları',
        Cost: 'Masraf',
        Output: 'Çıktı',
        Income: 'Gelir',
        Efficiency: 'Randıman',
        Load: 'Yük',
        Statistics: 'İstatistik',
        'Batch Analysis': 'Toplu Analiz',
        Saving: 'TasarrufⒺ',
        Plan: 'PlanⒺ',
        Prediction: 'PredictionⒺ',
        'Production': 'Production',
        'Space Production': 'Space Production',
        'Equipment Tracking': 'Ekipman Takibi',
        'Equipment Comparison': 'Ekipman Karşılaştırması',
        'Shopfloor Comparison': 'Ekipman Karşılaştırması',
        'Store Comparison': 'Ekipman Karşılaştırması',
        'Space Comparison': 'Ekipman Karşılaştırması',
        'Combined Equipment Comparison': 'Ekipman Karşılaştırması',
        'Tenant Comparison': 'Kiracı karşılaştırması',
        'Environment Monitor': 'Ortam İzleyicisi',
        'Meter Energy': 'Sayaç Enerjisi',
        'Meter Prediction': 'Sayaç TahminiⒺ',
        'Virtual Meter Prediction': 'Sanal Sayaç TahminiⒺ',
        'Offline Meter Prediction': 'Çevrimdışı Sayaç TahminiⒺ',
        'Meter Carbon': 'Meter CO2 Emisyonları',
        'Meter Cost': 'Sayaç Maliyeti',
        'Meter Trend': 'Ölçüm Trendi',
        'Meter Realtime': 'Gerçek Zamanlı Ölçüm Cihazı',
        'Meter Saving': 'Sayaç TasarrufuⒺ',
        'Meter Plan': 'Sayaç PlanıⒺ',
        'Master Meter Submeters Balance': 'Ana Sayaç Alt Sayaç Dengesi',
        'Meter Batch Analysis': 'Sayaç Toplu Analizi',
        'Meter Comparison': 'Sayaç Karşılaştırması',
        'Meter Tracking': 'Sayaç Takibi',
        'Virtual Meter Saving': 'Sanal Sayaç TasarrufuⒺ',
        'Virtual Meter Plan': 'Sanal Sayaç PlanıⒺ',
        'Virtual Meter Energy': 'Sanal Sayaç Enerji',
        'Virtual Meter Carbon': 'Sanal Meter CO2 Emisyonları',
        'Virtual Meter Cost': 'Sanal Sayaç Maliyeti',
        'Virtual Meter Batch Analysis': 'Sanal Ölçüm Toplu Analizi',
        'Virtual Meter Comparison': "Sanal Sayaç Karşılaştırması",
        'Offline Meter Energy': 'Çevrimdışı Sayaç Enerjisi',
        'Offline Meter Carbon': 'Çevrimiçi Meter CO2 Emisyonları',
        'Offline Meter Cost': 'Çevrimdışı Ölçüm Maliyeti',
        'Offline Meter Batch Analysis': 'Çevrimdışı Ölçüm Toplu Analizi',
        'Offline Meter Saving': 'Çevrimdışı Sayaç KaydetmeⒺ',
        'Offline Meter Plan': 'Çevrimdışı Sayaç PlanıⒺ',
        'Offline Meter Input': 'Çevrimdışı Sayaç Girişi',
        'Tenant Bill': 'Kiracı Faturası',
        'Energy Flow Diagram': 'Enerji Akış Diyagramı',
        'Distribution System': 'Dağıtım Sistemi',
        'SVG System': 'SCADA Görselleştirme Sistemi',
        'Faults Data': 'Hata',
        'Space Equipments': 'Uzay Ekipmanları',
        'Combined Equipments': 'Kombine Ekipmanlar',
        'Energy Storage Power Station List': 'List',
        'Energy Storage Power Station Details': 'Details',
        'Energy Storage Power Station Reporting': 'Reporting',
        'Energy Storage Power Station Alarm': 'Alarm',
        'Energy Storage Power Station Maintenance': 'Maintenance',
        'Enter Production': 'Enter Production',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
        'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
        'Multiple Energy Storage Power Stations List': 'List',
        'Single Energy Storage Power Station': 'Single Power Station',
        'Single Energy Storage Power Station Dashboard': 'Dashboard',
        'Single Energy Storage Power Station Details': 'Details',
        'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
        'Energy Storage Power Station Reports': 'Power Station Reports',
        'Energy Storage Power Station Reports Energy': 'Energy',
        'Energy Storage Power Station Reports Revenue': 'Revenue',
        'Energy Storage Power Station Reports Parameters': 'Parameters',
        'Photovoltaic Power Station List': 'Power Station List',
        'Photovoltaic Power Station Details': 'Details',
        'Photovoltaic Power Station Reporting': 'Reporting',
        'Photovoltaic Power Station Alarm': 'Alarm',
        'Photovoltaic Power Station Maintenance': 'Maintenance',
        'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
        'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
        'Multiple Photovoltaic Power Stations List': 'List',
        'Single Photovoltaic Power Station': 'Single Power Station',
        'Single Photovoltaic Power Station Dashboard': 'Dashboard',
        'Single Photovoltaic Power Station Details': 'Details',
        'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
        'Photovoltaic Power Station Reports': 'Power Station Reports',
        'Photovoltaic Power Station Reports Energy': 'Energy',
        'Photovoltaic Power Station Reports Revenue': 'Revenue',
        'Photovoltaic Power Station Reports Parameters': 'Parameters',
        'Work Order': 'Work Order',
        'Work Order Installation': 'Installation',
        'Work Order Repair': ' Repair',
        'Work Order Inspection': 'Inspection',
        'Total Number of Work Orders': 'Toplam İş Emri Sayısı',
        'Number of New Work Orders': 'Yeni İş Emri Sayısı',
        'Number of Inprogress Work Orders': 'Devam Eden İş Emri Sayısı',
        'Number of Done Work Orders': 'Tamamlanan İş Emri Sayısı',
        'Fuel Indicator': 'Yangın Kullanımı',
        'Charge Energy Indicator': 'Enerji Yükle',
        'Discharge Energy Indicator': 'Enerji Boşalt',
        'Charge Cost Indicator': 'Maliyet Yükle',
        'Discharge Revenue Indicator': 'Gelir Boşalt',
        'HVAC': 'HVAC',
        'Fire Control': 'Yangın Kontrolü',
        'Store Dashboard': 'Mağaza Panosu',
        'Comprehensive overview of store energy performance': 'Mağaza enerji performansı kapsamlı genel bakış',
        'Total Stores': 'Toplam Mağaza Sayısı',
        'Total Area': 'Toplam Alan',
        'Active Meters': 'Aktif Sayaçlar',
        'Active Alerts': 'Aktif Uyarılar',
        'Total Energy Consumption': 'Toplam Enerji Tüketimi',
        'Carbon Emissions': 'Karbon Emisyonları',
        'Current Period': 'Mevcut Dönem',
        'Energy Consumption by Category': 'Kategoriye Göre Enerji Tüketimi',
        'Cost Distribution by Category': 'Kategoriye Göre Maliyet Dağılımı',
        'Monthly Energy & Cost Trends': 'Aylık Enerji ve Maliyet Trendleri',
        'Top 5 Energy Consuming Stores': 'En Çok Enerji Tüketen İlk 5 Mağaza',
        'Energy Category Details': 'Enerji Kategorisi Detayları',
        'Store Performance Overview': 'Mağaza Performansı Genel Bakış',
        'YoY Change': 'Yıllık Değişim',
        'Per m²': 'm² Başına',
        'Usage Intensity': 'Kullanım Yoğunluğu',
        'Dashboard data loaded successfully': 'Pano verileri başarıyla yüklendi',
        'Failed to load dashboard data': 'Pano verileri yüklenemedi',
        'Store Name': 'Mağaza Adı',
        'Store Area': 'Mağaza Alanı',
        'Energy Consumption': 'Enerji Tüketimi',
        'Consumption': 'Tüketim',
        'last period': 'önceki dönem',
        // Tenant Dashboard
        'Tenant Dashboard': 'Kiracı Panosu',
        'Comprehensive overview of tenant energy performance': 'Kiracı enerji performansının kapsamlı görünümü',
        'Total Tenants': 'Toplam Kiracı Sayısı',
        'Tenant Performance Overview': 'Kiracı Performansına Genel Bakış',
        'Tenant Name': 'Kiracı Adı',
        'Tenant Area': 'Kiracı Alanı',
        'Tenant Type': 'Kiracı Türü',
        // Equipment Dashboard
        'Equipment Dashboard': 'Ekipman Gösterge Paneli',
        'Total Equipments': 'Toplam Ekipman',
        'Equipment Performance Overview': 'Ekipman Performansına Genel Bakış',
        'Equipment Name': 'Ekipman Adı',
        'Equipment Type': 'Ekipman Türü',
        'Total Energy': 'Toplam Enerji',
        'Total Sensors': 'Toplam Sensör',
        'Increment Rate': 'Artış Oranı',
        // Shopfloor Dashboard
        'Total Shopfloors': 'Toplam atölye sayısı',
        'Shopfloor Performance Overview': 'Atölye performansına genel bakış',
        'Shopfloor Name': 'Atölye adı',
        'Shopfloor Area': 'Atölye alanı',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Toplam Kombine Ekipman Sayısı',
        'Combined Equipment Performance Overview': 'Kombine Ekipman Performansına Genel Bakış',
        'Combined Equipment Name': 'Kombine Ekipman Adı',
        'Associated Equipments': 'İlgili Ekipmanlar',

        // Dashboard
        'Welcome to QiXuan': "QiXuan'ye Hoş Geldiniz",
        'An Industry Leading Energy Management System': 'Endüstri Lideri Enerji Yönetim Sistemi',
        "This Year's Consumption CATEGORY VALUE UNIT": 'Bu Yılın Tüketimi {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": 'Bu Yılın Maliyetleri {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": 'Bu Ayın Tüketimi {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Month's Costs CATEGORY VALUE UNIT": 'Bu Ayın Maliyetleri {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
            'Tüketim {{CATEGORY}} {{VALUE}} {{UNIT}} Geçen Yılın Aynı Döneminde',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
            'Maliyet {{CATEGORY}} {{VALUE}} {{UNIT}} Geçen Yılın Aynı Döneminde',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} Tüketim {{UNIT}}',
        'CATEGORY Costs UNIT': '{{CATEGORY}} Maliyet {{UNIT}}',
        // Entities
        Space: 'Uzay',
        Equipment: 'Ekipman',
        Meter: 'Metre',
        'Offline Meter': 'Çevrimdışı Ölçüm',
        'Virtual Meter': 'Sanal Ölçüm',
        Tenant: 'Kiracı',
        Store: 'Mağaza',
        Shopfloor: 'Üretim bölümü',
        'Combined Equipment': 'Kombine Ekipmanlar',
        'Cost Center': 'Maliyet Merkezi',
        Name: 'Ad',
        DisplayName: 'Görünen ad',
        UserName: 'Kullanıcı Adı',
        Description: 'Tarif',
        'Energy Category': 'Enerji Kategorisi',
        'Child Spaces': 'Çocuk Alanları',
        'Associated Equipment': 'İlgili Ekipmanlar',
        //Energy Categories
        Electricity: 'Elektrik',
        Water: 'Suyun',
        'Natural Gas': 'Doğalgaz',
        // SidePanelModal
        Settings: 'Ayarlar',
        'Set your own customized style': 'Kendi özelleştirilmiş stilinizi belirleyin',
        'Color Scheme': 'Renk Şeması',
        'Choose the perfect color mode for your app': 'Uygulamanız için mükemmel renk modunu seçin',
        Light: 'Işık',
        Dark: 'Koyu',
        'RTL Mode': 'RTL Modu',
        'Switch your language direction': 'Dil yönünüzü değiştirme',
        'Fluid Layout': 'Değişken Düzen',
        'Toggle container layout system': 'Konteyner düzen sistemini değiştir',
        'Navigation Position': 'Navigasyon Konumu',
        'Vertical': 'Dikey',
        'Top': 'Üst',
        'Combo': 'Kombinasyon',
        'Transparent': 'Şeffaf',
        'Inverted': 'Ters çevrilmiş',
        'Card': 'Kart',
        'Vibrant': 'Canlı',
        'Select a suitable navigation system for your web application':
            'Web uygulamanız için uygun bir navigasyon sistemi seçin',
        'Vertical Nav': 'Dikey Navigasyon',
        'Top Nav': 'En İyi Gezinti',
        'Vertical Navbar Style': 'Dikey Gezinme Çubuğu Stili',
        'Switch between styles for your vertical navbar': 'Dikey gezinme çubuğunuz için stiller arasında geçiş yapma',
        Language: 'Dil',
        'Switch between languages': 'Diller arasında geçiş yapma',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'Gördüklerinizi beğendiniz mi?',
        'Get QiXuan now': "QiXuan'yi şimdi edinin",
        Purchase: 'Enterprise Edition',
        ContactInfo: 'Iletisim Bilgileri',
        ProductWebsite: 'Urun Web Sitesi',
        CompanyWebsite: 'Sirket Web Sitesi',
        SalesPhone: 'Satis Telefonu',
        // Query Panel
        'Base Period Begins': 'Baz Dönemi Başlıyor',
        'Base Period Ends': 'Baz Dönem Biter',
        'Comparison Types': 'Karşılaştırma Türleri',
        'Year-Over-Year': 'Yıldan Yıla',
        'Month-On-Month': 'Aydan Aya',
        'Free Comparison': 'Ücretsiz Karşılaştırma',
        'None Comparison': 'Karşılaştırma Yok',
        'Reporting Period Begins': 'Raporlama Dönemi Başlıyor',
        'Reporting Period Ends': 'Raporlama Dönemi Sona Eriyor',
        '(Optional)': '(Opsiyonel)',
        'Period Types': 'Dönem Türleri',
        Yearly: 'Yıllık',
        Monthly: 'Aylık',
        Weekly: 'Haftalık',
        Daily: 'Günlük',
        Hourly: 'Saatlik',
        Submit: 'Gönder',
        'Input Energy Category': 'Giriş Enerji Kategorisi',
        'Output Energy Category': 'Çıkış Enerjisi Kategorisi',
        'Fraction Parameter': 'Kesir Parametresi',
        Search: 'Aramak',
        //DateRangePicker
        sunday: 'Su',
        monday: 'Mo',
        tuesday: 'Tu',
        wednesday: 'We',
        thursday: 'Th',
        friday: 'Fr',
        saturday: 'Sa',
        ok: 'TAMAM',
        today: 'Bugün',
        yesterday: 'Dün',
        hours: 'Saat',
        minutes: 'Tutanak',
        seconds: 'Saniye',
        last7Days: 'Son 7 Gün',
        tomorrow: 'Yarın',
        dayAfterTomorrow: 'Öbür gün',
        next7Days: 'Önümüzdeki 7 gün',
        'Select Date Range': 'Tarih Aralığını Seçin',
        //Card Summaries and Line Charts
        'Base Period': 'Baz Dönem',
        'Reporting Period': 'Raporlama Dönemi',
        'Per Unit Area': 'Birim Alan Başına',
        'Per Capita': 'Per Capita',
        'Per Unit Production': 'Birim Üretim Başına',
        Baseline: 'Taban çizgisi',
        Actual: 'Gerçek',
        'Baseline Value - Actual Value': 'Taban çizgisi - Gerçek',
        'Average Load': 'Ortalama Yük',
        'Maximum Load': 'Maksimum Yük',
        'Load Factor': 'Yük Faktörü',
        'Ratio of Average Load to Maximum Load': 'Ortalama Yükün Maksimum Yüke Oranı',
        'Carbon Dioxide Emissions by Energy Category': 'Enerji Kategorisine Göre Karbondioksit Emisyonları',
        'Costs by Energy Category': 'Enerji Kategorisine Göre Maliyetler',
        'Incomes by Energy Category': 'Enerji Kategorisine Göre Gelirler',
        'Electricity Consumption by Time-Of-Use': 'Kullanım Süresine Göre Elektrik Tüketimi',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use':
            'Kullanım Süresine Göre Elektrik Karbondioksit Emisyonları',
        'Electricity Cost by Time-Of-Use': 'Kullanım süresine göre elektrik maliyeti',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Enerji Maddeleri Tarafından Tüketim',
        'Ton of Standard Coal by Energy Category': 'Enerji Kategorisine Göre Ton Standart Kömür (TCE)',
        'Ton of Carbon Dioxide Emissions by Energy Category':
            'Enerji Kategorisine Göre Tonlarca Karbondioksit Emisyonu (TCO2E)',
        'Reporting Period Consumption CATEGORY UNIT': 'Raporlama Dönemi Tüketimi {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{EQUIPMENT}} Raporlama Dönemi Tüketimi {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Raporlama Dönemi Tüketimi {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'Raporlama Dönemi Tüketimi {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'Baz Dönem Tüketimi {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT': 'Raporlama Dönemi Tüketimi {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
            'Raporlama Dönemi Tüketimi {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT': 'Baz Dönem Tüketimi {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': 'Enerji Kategorisine Göre Çocuk Alanı Oranı {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'Çocuk Alanı Toplam Oranı',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
            'Raporlama Dönemi Karbondioksit Emisyonları {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Raporlama Dönemi Karbondioksit Emisyonları {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Baz Dönem Karbondioksit Emisyonları {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'Raporlama Dönemi Maliyetleri {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'Raporlama Dönemi Maliyetleri {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'Baz Dönem Maliyetleri {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'Raporlama Dönemi Çıktısı {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} Raporlama Dönemi Çıktısı {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Raporlama Dönemi Çıktısı {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': 'Raporlama Dönemi Çıktısı {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'Baz Dönem Çıkışı {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'Raporlama Dönemi Geliri {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'Raporlama Dönemi Geliri {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'Baz Dönem Geliri {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'Raporlama Dönemi Toplam Geliri {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': 'Raporlama Dönemi Kümülatif Verimliliği {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
            '{{EQUIPMENT}} Raporlama Dönemi Kümülatif Verimliliği {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Raporlama Dönemi Kümülatif Kapsamlı Verimlilik {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Raporlama Dönemi Kümülatif Kapsamlı Verimlilik {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Baz Dönem Kümülatif Kapsamlı Verimlilik {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'Anlık Verimlilik {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Anlık Verimlilik {{UNIT}}',
        'Equipment Efficiency Indicator': 'Ekipman Enerji Verimliliği Göstergesi',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Anlık Kapsamlı Verimlilik {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': 'Raporlama Dönemi Kümülatif Verimliliği {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
            'Raporlama Dönemi Kümülatif Verimliliği {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'Baz Dönem Kümülatif Verimlilik {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT': 'Baz Dönem Kümülatif Verimlilik {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'Baz Dönem {{CATEGORY}} Maksimum Yük {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'Raporlama Dönemi {{CATEGORY}} Maksimum Yük {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': 'Raporlama Dönemi {{CATEGORY}} Ortalama Yük {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'Raporlama Dönemi {{CATEGORY}} Yük Faktörü',
        'Base Period CATEGORY Average Load VALUE UNIT': 'Baz Dönem {{CATEGORY}} Ortalama Yük {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'Raporlama Dönemi {{CATEGORY}} Ortalama Değer {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'Raporlama Dönemi {{CATEGORY}} Maksimum Değer {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'Raporlama Dönemi {{CATEGORY}} Minimum Değer {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'Raporlama Dönemi {{CATEGORY}} Aritmetik Ortalama {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': 'Raporlama Dönemi {{CATEGORY}} Medyan (Orta Değer) {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'Raporlama Dönemi {{CATEGORY}} Numune Standart Sapması {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'Raporlama Dönemi {{CATEGORY}} Örnek Varyans {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
            'Raporlama Dönemi Tasarrufu {{CATEGORY}} (Taban çizgisi - Gerçek) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
            'Raporlama Dönemi Azaldı {{CATEGORY}} (Taban çizgisi - Gerçek) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': 'Raporlama Dönemi Tasarrufu {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'Baz Dönem Tasarrufu {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT':
            'Raporlama Dönemi Ana Sayaç Tüketimi {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
            'Raporlama Dönemi Ana Sayaç Tüketimi {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT':
            'Raporlama Dönemi Alt Sayaç Tüketimi {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
            'Raporlama Dönemi Alt Sayaç Tüketimi {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'Raporlama Dönemi Farkı {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'Raporlama Dönemi Yüzde Farkı',
        'Reporting Period Difference CATEGORY VALUE UNIT': 'v {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Trend Values': 'Trend Değerleri',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'Arıza Listesi',
        'Reporting Period Number of Fault VALUE': 'Raporlama Dönemi Hata Sayısı {{VALUE}}',
        'All Faults': 'Tüm Hatalar',
        'Space Faults': 'Uzay Fayları',
        'Number of All Faults': 'Tüm Arızaların Sayısı',
        'Number of Space Faults': 'Uzay Hatalarının Sayısı',
        'Total Number of Faults': 'Total Number of Faults',
        'Number of New Faults': 'Number of New Faults',
        'Number of Inprogress Faults': 'Number of Inprogress Faults',
        'Number of Done Faults': 'Number of Done Faults',
        //Data Panels
        'Ton of Standard Coal': 'Ton Standart Kömür',
        'Ton of Carbon Dioxide Emissions': 'Tonlarca karbondioksit emisyonu',
        'Carbon Emissions Per Unit Of Energy Consumption': 'Enerji tüketim birimi başına karbon emisyonları',
        'Operating Characteristic Curve': 'işletim karakteristik eğri',
        Tariff: 'Tarife',
        'Detailed Data': 'Detaylı Veri',
        'Child Spaces Data': 'Alt Alanlar Verileri',
        'Associated Equipment Data': 'İlişkili Ekipman Verileri',
        'This Year': 'Bu Yıl',
        'The Same Period Last Year': 'Geçen yılın aynı döneminde',
        'This Month': 'Bu Ay',
        'This Day': 'Bu Gün',
        Total: 'Toplam',
        'No data found': 'Veri bulunamadı',
        Export: 'Ihracat',
        'AI Analysis': 'AI Analizi',
        Datetime: 'Tarih-saat',
        'Time-Of-Use Type': 'Kullanım Süresi Türü',
        'Top-Peak': 'Üst Düzey Zirve',
        'On-Peak': 'Zirvede',
        'Mid-Peak': 'Orta Tepe Noktası',
        'Off-Peak': 'Peak',
        'Deep': 'Deep-Valley',
        Percentage: 'Yüzde',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'Enerji Değer Noktasının son saatindeki eğilim',
        Circuit: 'Devre',
        Point: 'Nokta',
        'Realtime Value': 'Gerçek Zamanlı Değer',
        //Meter Tracking
        'Meter List': 'Sayaç Listesi',
        'Edit Meter': 'Düzenlemek',
        'Start Value': 'Başlangıç Değeri',
        'End Value': 'Bitiş Değeri',
        'Difference Value': 'Fark Değeri',
        'Start Integrity Rate': 'Başlangıç Bütünlük Oranı(%)',
        'End Integrity Rate': 'Son Bütünlük Oranı(%)',
        'Full Integrity Rate': 'Tam Bütünlük Oranı(%)',
        'Start Integrity Rate Description': 'Başlangıç Veri Bütünlüğü Oranı: İstatistiksel dönemde tüm sayaçlar arasında başlangıç anında enerji tüketimi okumasını başarıyla alan sayaçların oranı',
        'End Integrity Rate Description': 'Bitiş Veri Bütünlüğü Oranı: İstatistiksel dönemde tüm sayaçlar arasında bitiş anında enerji tüketimi okumasını başarıyla alan sayaçların oranı',
        'Full Integrity Rate Description': 'Tam Veri Bütünlüğü Oranı: İstatistiksel dönemde tüm sayaçlar arasında hem başlangıç hem de bitiş anında enerji tüketimi okumasını başarıyla alan sayaçların oranı',
        //Equipment Tracking
        'Equipment List': 'Ekipman Listesi',
        'Edit Equipment': 'Düzenlemek',
        //Profile Dropdown
        Feedback: 'Geri besleme',
        'Account Settings': 'Hesap Ayarları',
        Logout: 'Oturum kapatma',
        //Authentication
        'Log in': 'Oturum aç',
        'Email address': 'E-posta adresi',
        'Phone Number': 'Telefon numarası',
        Password: 'Parola',
        CaptchaCode: 'Arjantin',
        Refresh: 'Yenilemek',
        'Remember me': 'Beni hatırla',
        'Logged in as ': 'Şu şekilde oturum açtım: ',
        'Forgot Password?': 'Şifremi Unuttum?',
        'Forgot your password?': 'Şifrenizi mi unuttunuz?',
        "Enter your email and we'll send you a reset link": 'E-postanızı girin, size bir sıfırlama bağlantısı gönderelim',
        "Enter your email and we'll send you a registration link":
            'E-posta adresinizi girin, size bir kayıt bağlantısı gönderelim',
        'Reset Password': 'Şifreyi Sıfırla',
        'Thanks for using QiXuan!': "QiXuan'yi kullandığınız için teşekkür ederiz!",
        'You are now successfully signed out': 'Artık oturumunuz başarıyla kapatıldı',
        'Return to Login': 'Girişe Dön',
        'Please check your email!': 'Lütfen e-postanızı kontrol edin!',
        'An email has been sent to ': 'Şu adrese bir e-posta gönderildi: ',
        'Please click on the included link to reset your password':
            'Şifrenizi sıfırlamak için lütfen birlikte verilen bağlantıya tıklayın',
        'Please click on the included link to register your account':
            'Hesabınızı kaydetmek için lütfen dahil edilen bağlantıya tıklayın',
        'An email with password reset link is sent to ':
            'Parola sıfırlama bağlantısı içeren bir e-posta şu adrese gönderilir: ',
        'Change Password': 'Şifre Değiştir',
        'Old Password': 'Eski Şifre',
        'New Password': 'Yeni Şifre',
        'Confirm Password': 'Şifreyi Onayla',
        'Update Password': 'Şifreyi Güncelle',
        'Password has been changed!': 'Şifre değiştirildi!',
        'Verification code has been sent to your inbox. \
  Please copy it to the input box below..':
            'Doğrulama kodu gelen kutunuza gönderildi. \
  Lütfen aşağıdaki giriş kutusuna kopyalayın.',
        'New to QiXuan': "QiXuan'de yeni",
        'Create an account': 'Bir hesap oluşturun',
        'EMAIL Account registration successful': '{{EMAIL}} Hesap kaydı başarılı',
        'Thanks for verifying your account!': 'Hesabınızı doğruladığınız için teşekkür ederiz!',
        'Your code is': 'Kodunuz',
        'Send verification code': 'Doğrulama kodu gönder',
        'Please wait for NUMBER seconds': 'Lütfen bekleyin {{NUMBER}} Saniye',
        'Password reset': 'Parola sıfırlama',
        'Please wait for approval': 'Lütfen onay için bekleyin',
        //notification
        Notifications: 'Bildirim',
        'Mark all as read': 'Tümünü okundu olarak işaretle',
        'View all': 'Tüm',
        'Notification New': 'YENİ',
        'Notification Earlier': 'ÖNCEKİ',
        'Notification List': 'Bildirim Listesi',
        'Bulk actions': 'Toplu işlemler',
        'Notification Subject': 'Konu',
        'Notification Created Datetime': 'Oluşturulma TarihiSaat',
        'Notification Priority': 'Öncelik',
        'Notification Message': 'İleti',
        'Notification Status': 'Durum',
        'Notification Mark As Read': 'Okundu Olarak İşaretle',
        'Notification Mark As Acknowledged': 'Kabul',
        'Notification Low': 'Alçak',
        'Notification Medium': 'Orta',
        'Notification High': 'Yüksek',
        'Notification Critical': 'Kritik',
        'Notification Unread': 'Okunmamış',
        'Notification Read': 'Okumak',
        'Notification Acknowledged': 'Kabul',
        'Notification Archive': 'Arşiv',
        'Notification Delete': 'Silmek',
        'Notification Apply': 'Uygulamak',
        'Notification Start Datetime': 'Tarih Saati Başlat',
        'Notification End Datetime': 'Bitiş TarihiSaat',
        'Notification Update Datetime': 'Tarih Saati Güncelle',
        //Monitoring
        'Run Commands': 'Komutları Çalıştır',
        'Pin Code': 'Posta Kodu',
        'Unlock': 'Kilidini aç',
        'Set Value': 'Değer Ayarla',
        'Fault Alarms': 'Arıza Alarmları',
        'Instantaneous Efficiency VALUE UNIT': 'Anlık Verimlilik {{VALUE}} {{UNIT}}',
        'Communication Online': 'Çevrimiçi',
        'Communication Offline': 'Çevrimdışı',
        'Equipment Status': 'Eğitim durumu',
        'Equipment Running': 'Koşarak',
        'Equipment Stopped': 'Durdu',
        'Show Up to': 'Şuraya Kadar Göster',
        All: 'Tüm',
        'FROM - TO of TOTAL': '{{FROM}} - {{TO}} in {{TOTAL}} Alet -leri',
        //Microgrid
        'Microgrid Energy': 'Mikro Şebeke Enerjisi',
        'Microgrid Revenue': 'Mikro Şebeke Geliri',
        'Microgrid Carbon': 'Mikro Şebeke Karbon',
        'Photovoltaic Generation': 'Fotovoltaik Üretim',
        'EV Charger Consumption': 'EV Şarj Cihazı Tüketimi',
        'Load Consumption': 'Yük Tüketimi',
        'Grid Buy': 'Şebeke Satın Alma',
        'Grid Sell': 'Şebeke Satış',
        'EV Charger': 'EV Şarj Cihazı',
        'Heat Pump': 'Isı Pompası',
        'Photovoltaic': 'Fotovoltaik',
        'PCS Run State': 'PCS Çalıştırma Durumu',
        'PCS Unknown': 'Bilinmemiş',
        'PCS Initializing': 'Initializing',
        'PCS Standby': 'Standby',
        'PCS Shutdown': 'Kapa çeneni',
        'PCS Fault': 'Hata',
        'PCS Running': 'Çıkıyor',
        'Battery Power': 'Battery power',
        'Photovoltaic Power': 'Fotovoltaik gücü',
        'Grid Power': 'Grid gücü',
        'Load Power': 'Yükleme gücü',
        Reporting: 'Rapor',
        Maintenance: 'Yedekleme',
        'Serial Number': 'Seri Numarası',
        Address: 'Adres',
        'Postal Code': 'Posta Kodu',
        'Rated Capacity': 'Değerli Kapacite',
        'Rated Power': 'Değerli Güç',
        Latitude: 'Latitude',
        Longitude: 'Yükseklik',
        'Strategy Management': 'Strateji yönetimi',
        'Charging Schedule': 'Yükleme Zamanı',
        'Charge Start Time': 'Yükleme Başlangıç Zamanı',
        'Charge End Time': 'Charge End Time',
        'Discharge Start Time': 'Başlangıç Zamanını Aç',
        'Discharge End Time': 'Açırma sonu zamanı',
        'Total Rated Power': 'Toplam Nominal Güç',
        'Total Rated Capacity': 'Toplam Nominal Kapasite',
        "Today's Charge": "Bugünün ödeme tutarı",
        "Today's Discharge": "Bugün taburcu olun",
        "Today's Generation": "Günümüzün enerji üretimi",
        'Total Fuel Consumption': 'Total Fuel Consumption',
        'Total Charge': 'Toplam ücret',
        'Total Discharge': 'toplam deşarj',
        'Total Generation': 'Toplam Üretim',
        'Total Revenue': 'Toplam gelir',
        'Total Photovoltaic Generation': 'Toplam Fotovoltaik Üretim',
        'Total EV Charger Consumption': 'Toplam EV Şarj Cihazı Tüketimi',
        'Total Load Consumption': 'Toplam Yük Tüketimi',
        'Total Grid Buy': 'Toplam Şebeke Satın Alma',
        'Total Grid Sell': 'Toplam Şebeke Satış',
        'Total Efficiency': 'Toplam Verimlilik',
        'Discharge Achievement Rate': 'Deşarj Başarı Oranı',
        // Revenue Indicator
        "Today's Cost": "Today's Cost",
        "Today's Income": "Today's Income",
        "Total Cost": "Total Cost",
        "Total Income": "Total Income",
        "Today's Revenue": "Today's Revenue",

        'Revenue Ranking': 'Gelir sıralaması',
        'Efficiency Ranking': 'Verimlilik sıralaması',
        'Charge Ranking': 'Şarj kapasitesi sıralaması',
        'Discharge Ranking': 'Deşarj sıralaması',
        'Number of Microgrids': 'Mikro şebeke sayısı',
        'Number of Power Stations': 'Elektrik santrallerinin sayısı',
        'Microgrid List': 'Mikro Şebeke Listesi',
        'Select Microgrid': 'Mikro Şebeke Seç',
        'Previous Page': 'Önceki sayfa',
        'Next Page': 'Sonraki Sayfa',
        '7 Days': '7 gün',
        'Charge UNIT': 'Şarj {{UNIT}}',
        'Discharge UNIT': 'deşarj {{UNIT}}',
        'Generation UNIT': 'elektrik üretmek {{UNIT}}',
        'Energy Indicator': 'enerji endeksi',
        'Revenue Indicator': 'Verim göstergesi',
        'Carbon Indicator': 'karbon indeksi',

        // Energy Storage Power Station
        'Battery Operating State': 'Batarya İşlemi Durumu',
        'Battery State': 'Batarya durumu',
        'Battery Unknown': 'Bilinmemiş',
        'Battery Stopped': 'Durduruldu',
        'Battery Reserved': 'Reserved', // 0
        'Battery Fault': 'Hata', // 1
        'Battery Warning': 'Uyarı', // 2
        'Battery Standby': 'Standby', // 3
        'Battery Prohibit DisCharging': 'Yüklemeyi yasakla', // 4
        'Battery Prohibit Charging': 'Yüklemeyi yasakla', // 5
        'Battery Normal': 'Normal', // 6
        'Battery Charging': 'Yüklenmek', // 7
        'Battery Discharging': 'During discharge', // 8
        'Battery Idle': 'Idle', // 9
        'Phase of Lifecycle': 'Lifecycle Fazi',
        'Use Phase': 'Use Phase',
        'Commissioning Phase': 'Komisyon Fazi',
        'Commissioning Date': 'Commissioning Date',
        'Installation Phase': 'Kurulum Aşaması',
        'Device Status': 'Cihaz Durumu',
        'Basic Information': 'Temel Bilgiler',
        'Gateway': 'Gateway',
        'Grid Meter': 'Grid Meter',
        'Load Meter': 'Load Meter',
        'ESS Meter': 'ESS Meter',
        'Total Active Power': 'Total Active Power',
        'Active Power A': 'Active Power A',
        'Active Power B': 'Active Power B',
        'Active Power C': 'Active Power C',
        'Total Reactive Power': 'Total Reactive Power',
        'Reactive Power A': 'Reactive Power A',
        'Reactive Power B': 'Reactive Power B',
        'Reactive Power C': 'Reactive Power C',
        'Total Apparent Power': 'Total Apparent Power',
        'Apparent Power A': 'Apparent Power A',
        'Apparent Power B': 'Apparent Power B',
        'Apparent Power C': 'Apparent Power C',
        'Total Power Factor': 'Total Power Factor',
        'Active Energy Import': 'Active Energy Import',
        'Active Energy Export': 'Active Energy Export',
        'Active Energy Net': 'Active Energy Net',

        'Generator': 'Generator',

        // Photovoltaic Power Station
        'Invertor': 'invertörler',
        'Invertor Run State': 'Çalıştırma Durumu',
        'Invertor Unknown': 'Bilinmemiş',
        'Invertor Initializing': 'Initializing',
        'Invertor Standby': 'Standby',
        'Invertor Shutdown': 'Kapa çeneni',
        'Invertor Fault': 'Hata',
        'Invertor Running': 'Çıkıyor',

        //Advanced Reporting & Knowledge base
        'Created Datetime': 'Oluşturulma Tarihi',
        'File Format': 'Dosya Biçimi',
        'File Size': 'Dosya Boyutu',
        Uploader: 'Yükleyici',
        //Error
        "The page you're looking for is not found": 'Aradığınız sayfa bulunamadı',
        "Make sure the address is correct and that the page hasn't moved. ":
            'Adresin doğru olduğundan ve sayfanın taşınmadığından emin olun. ',
        'If you think this is a mistake,': 'Bunun bir hata olduğunu düşünüyorsanız,',
        'contact us': 'bize ulaşın',
        'Take me home': 'Beni eve götür',
        'Whoops, something went wrong!': 'Whoops, bir şeyler ters gitti!',
        'Try refreshing the page, or going back and attempting the action again. ':
            'Sayfayı yenilemeyi veya geri dönüp eylemi yeniden denemeyi deneyin. ',
        'If this problem persists,': 'Bu sorun devam ederse,',
        'Captcha Error': 'Captcha Hatası',
        'Confirm Password Error': 'Onay parolası eşleşmiyor',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'Geçersiz bir parola sıfırlama \
bağlantısına tıklamış gibi görünüyorsunuz. Lütfen tekrar deneyin.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'Geçersiz bir kayıt hesabı \
bağlantısına tıklamış gibi görünüyorsunuz. Lütfen tekrar deneyin.',
        //Tenant Bill
        'Lease Contract Number': 'Kira Sözleşme Numarası',
        Download: 'İndirmek',
        Print: 'Yazdırmak',
        'Payment Notice': 'Ödeme Bildirimi',
        'Bill To': 'Fatura Gönder',
        'Bill Number': 'Fatura Numarası',
        'Bill Date': 'Fatura Tarihi',
        'Payment Due Date': 'Ödeme Son Tarihi',
        'Amount Payable': 'Ödenecek Tutar',
        'Billing Period Start': 'Fatura Dönemi Başlangıcı',
        'Billing Period End': 'Fatura Dönemi Sonu',
        Quantity: 'Miktar',
        Price: 'Fiyat',
        Amount: 'Miktar',
        Subtotal: 'Ara toplam',
        'VAT Output Tax': 'KDV Çıkış Vergisi',
        'Total Amount Payable': 'Ödenecek Toplam Tutar',
        'Please make sure to pay on or before the payment due date above':
            'Lütfen yukarıdaki son ödeme tarihinde veya öncesinde ödeme yaptığınızdan emin olun',
        'Send money to the following account': 'Aşağıdaki hesaba para gönderin',
        'Account Name': 'Hesap Adı',
        'Bank Name': 'Banka Adı',
        'Bank Address': 'Banka Adresi',
        'RMB Account': 'RMB Hesabı',
        // button
        'Toggle Navigation': 'Navigasyonu Değiştir',
        // working calendar
        'Working Days': 'Çalışma Günleri',
        'Non Working Days': 'Çalışma Dışı Günler',
        'Select Row': 'Lütfen Veri Satırı Seçiniz',
        // Offline Meter Input
        'Daily Value': 'Günlük Değer',
        Date: 'Tarih',
        'Successfully Saved': 'Başarıyla Kaydedildi',
        'Previous Data Is Empty': 'Önceki veriler boş',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': 'Bad request',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not  found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
        'API.CONTACT_NOT_FOUND': 'Contact not found',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
        'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
        'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
        'API.COST_FILE_NOT_FOUND': 'Cost file not found',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
        'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
        'API.DATABASE_ERROR': 'Database error',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
        'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
        'API.EMAIL_NOT_FOUND': 'Email not found',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
        'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
        'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
        'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
        'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
        'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
        'API.ERROR': 'Error',
        'API.EXCEPTION': 'Exception',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
        'API.GATEWAY_NOT_FOUND': 'Gateway not found',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': 'Invalid ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': 'Invalid address',
        'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
        'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': 'Invalid area value',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': 'Invalid baud rate',
        'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': 'Invalid category',
        'API.INVALID_CHANNEL': 'Invalid channel',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': 'Invalid connection',
        'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
        'API.INVALID_CONTACT_ID': 'Invalid contact id',
        'API.INVALID_CONTACT_NAME': 'Invalid contact name',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
        'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
        'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
        'API.INVALID_DATE_LOCAL': 'Invalid date local',
        'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': 'Invalid display name',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
        'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': 'Invalid email',
        'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
        'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
        'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
        'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
        'API.INVALID_END_DATETIME': 'Invalid end datetime',
        'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
        'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
        'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
        'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
        'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
        'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': 'Invalid expression',
        'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
        'API.INVALID_FDD_CODE': 'Invalid fdd code',
        'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
        'API.INVALID_FROM_ADDR': 'Invalid from addr',
        'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
        'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
        'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
        'API.INVALID_IS_ENABLED': 'Invalid is enabled',
        'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
        'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
        'API.INVALID_KGCE': 'Invalid kgce',
        'API.INVALID_KGCO2E': 'Invalid kgco2e',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
        'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
        'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
        'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
        'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
        'API.INVALID_MENU_ID': 'Invalid menu id',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': 'Invalid meter id',
        'API.INVALID_METER_NAME': 'Invalid meter name',
        'API.INVALID_METER_UUID': 'Invalid meter uuid',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic ID',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Invalid name value',
        'API.INVALID_NEW_PASSWORD': 'Invalid new password',
        'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
        'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
        'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
        'API.INVALID_OBJECT_TYPE': 'Invalid object type',
        'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
        'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
        'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
        'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
        'API.INVALID_OLD_PASSWORD': 'Invalid old password',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
        'API.INVALID_PASSWORD': 'Invalid password',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
        'API.INVALID_PEAK_LOAD': 'Invalid peak load',
        'API.INVALID_PERIOD_TYPE': 'Invalid period type',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': 'Invalid point id',
        'API.INVALID_POINT_NAME': 'Invalid point name',
        'API.INVALID_PORT': 'Invalid port',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': 'Invalid priority',
        'API.INVALID_PRIVILEGE': 'Invalid privilege',
        'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
        'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
        'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
        'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': 'Invalid reply',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
        'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
        'API.INVALID_RULE_ID': 'Invalid rule id',
        'API.INVALID_RULE_NAME': 'Invalid rule name',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': 'Invalid sensor id',
        'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SERIAL_PORT': 'Invalid serial port',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
        'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
        'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
        'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
        'API.INVALID_SPACE_ID': 'Invalid space id',
        'API.INVALID_SPACE_NAME': 'Invalid space name',
        'API.INVALID_SPACE_UUID': 'Invalid space uuid',
        'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
        'API.INVALID_START_DATETIME': 'Invalid start datetime',
        'API.INVALID_STATUS': 'Invalid status',
        'API.INVALID_STORE_ID': 'Invalid store id',
        'API.INVALID_STORE_NAME': 'Invalid store name',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
        'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
        'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
        'API.INVALID_STORE_UUID': 'Invalid store uuid',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': 'Invalid SVG',
        'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
        'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
        'API.INVALID_TARIFF_ID': 'Invalid tariff id',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
        'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
        'API.INVALID_TENANT_ID': 'Invalid tenant id',
        'API.INVALID_TENANT_NAME': 'Invalid tenant name',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
        'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
        'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
        'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
        'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
        'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
        'API.INVALID_TOKEN': 'Invalid token',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
        'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
        'API.INVALID_UNITS': 'Invalid units',
        'API.INVALID_USER_ID': 'Invalid user id',
        'API.INVALID_USER_NAME': 'Invalid user name',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
        'API.INVALID_USER_PHONE': 'Invalid user phone',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
        'API.INVALID_USER_UUID': 'Invalid user uuid',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
        'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
        'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
        'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
        'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
        'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
        'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
        'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
        'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
            'Master meter does not belong to same energy category',
        'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
        'API.MENU_NOT_FOUND': 'Menu not found',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
        'API.METER_NOT_FOUND': 'Meter not found',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
        'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
        'API.NOT_FOUND': 'Not found',
        'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
        'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
        'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
        'API.PASSWORDS_MATCH': 'New password is the same as the old password',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
        'API.POINT_NOT_FOUND': 'Point not found',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
        'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
        'API.RULE_NOT_FOUND': 'Rule not found',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
        'API.SENSOR_NOT_FOUND': 'Sensor not found',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
        'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
        'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
        'API.SPACE_NOT_FOUND': 'Space not found',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
        'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
        'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
        'API.STORE_NOT_FOUND': 'Store not found',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
        'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
        'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
        'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
        'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
        'API.TARIFF_IN_USE': 'Tariff in use',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
        'API.TARIFF_NOT_FOUND': 'Tariff not found',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
        'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
        'API.TENANT_NOT_FOUND': 'Tenant not found',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
        'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
        'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
        'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
            'There is relation with combined equipment parameters',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
        'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
        'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
        'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
        'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
        'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Sanal güç santralleri ile ilişkisi var',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
        'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
        'API.USER_NOT_FOUND': 'User not found',
        'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
        'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
        'API.USER_SESSION_NOT_FOUND': 'User session not found',
        'API.USER_SESSION_TIMEOUT': 'User session timeout',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
        'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
        'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

        MasterMeter: 'Sažetak tablica',
        SubMeter: 'Podtablica',
        'Power Quality': 'Kualiti kuasa',
        'About Power Quality': 'Perihal kualiti kuasa',
        Category: 'Kategori',
        Type: 'Jenis',
        Unit: 'Unit',
        Limit: 'Had',
        'Normal Limit': 'Had normal',
        'Severe Limit': 'Had teruk',
        Compliance: 'Kadar pematuhan',
        'Worst Deviation': 'Sisihan terburuk',
        'Worst Time': 'Masa terburuk',
        'Severe Exceed Count': 'Kiraan lebihan teruk',
        'Worst Unbalance': 'Ketidakseimbangan maksimum',
        Hz: 'Hz',
        voltage: 'Voltan',
        current: 'Arus',
        frequency: 'Frekuensi',
        voltage_deviation: 'Sisihan voltan',
        current_unbalance: 'Ketidakseimbangan arus',
        voltage_unbalance: 'Ketidakseimbangan voltan',
        mean_deviation_pct: 'Sisihan purata (%)',
        p95_abs_deviation_pct: 'Sisihan mutlak P95 (%)',
        mean_abs_deviation_hz: 'Sisihan mutlak purata (Hz)',
        p95_abs_deviation_hz: 'Sisihan mutlak P95 (Hz)',
        mean_unbalance_pct: 'Ketidakseimbangan purata (%)',
        p95_unbalance_pct: 'Ketidakseimbangan P95 (%)',
        count: 'Kiraan',
        min: 'Min',
        max: 'Maks',
        mean: 'Purata',
        std: 'Sisihan piawai',
        p5: 'P5',
        p95: 'P95'
    }
};
